import React from 'react';

const ACTION_LABELS = {
  create: 'created this record',
  delete: 'deleted this record',
  convert: 'converted lead to customer',
  unconvert: 'reverted conversion',
};

const timeAgo = (date) => {
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const truncate = (val, max = 60) => {
  if (val == null) return '—';
  const s = String(val);
  return s.length > max ? s.slice(0, max) + '…' : s;
};

const ChangeHistory = ({ history, loading }) => {
  if (loading) return <div style={{ fontSize: '12px', color: 'var(--color-secondary)', padding: '8px 0' }}>Loading history...</div>;
  if (!history || history.length === 0) return <div style={{ fontSize: '12px', color: 'var(--color-secondary)', padding: '8px 0' }}>No history yet</div>;

  return (
    <div style={{ fontSize: '12px' }}>
      {history.map((entry) => (
        <div key={entry.id} style={{ display: 'flex', gap: '8px', padding: '6px 0', borderBottom: '1px solid var(--color-gray-100)' }}>
          <div style={{ flex: '0 0 auto', width: '6px', height: '6px', borderRadius: '50%', background: entry.action === 'create' ? '#059669' : entry.action === 'delete' ? '#DC2626' : '#6366F1', marginTop: '5px' }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div>
              <span style={{ fontWeight: 600 }}>{entry.user?.loginId || 'system'}</span>
              {' '}
              {ACTION_LABELS[entry.action] || (
                <span>
                  updated{' '}
                  {entry.changes?.map((c, i) => (
                    <span key={i}>
                      {i > 0 && ', '}
                      <span style={{ fontWeight: 600 }}>{c.field}</span>
                      {' '}
                      <span style={{ color: '#DC2626', textDecoration: 'line-through' }}>{truncate(c.from)}</span>
                      {' → '}
                      <span style={{ color: '#059669' }}>{truncate(c.to)}</span>
                    </span>
                  ))}
                </span>
              )}
            </div>
            <div style={{ color: 'var(--color-secondary)', fontSize: '11px', marginTop: '2px' }} title={new Date(entry.createdAt).toLocaleString()}>
              {timeAgo(entry.createdAt)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChangeHistory;
